
(function () {
  if (window.__z9JdgmA11yInit) return;
  window.__z9JdgmA11yInit = true;

  function patch(root) {
    if (!root || !root.querySelectorAll) return;

    var prev = root.querySelectorAll('button.jdgm-arrow[onclick*="PreviousCard"]:not([aria-label])');
    prev.forEach(function (b) { b.setAttribute('aria-label', 'Previous review'); });

    var next = root.querySelectorAll('button.jdgm-arrow[onclick*="NextCard"]:not([aria-label])');
    next.forEach(function (b) { b.setAttribute('aria-label', 'Next review'); });

    var arrows = root.querySelectorAll('button.jdgm-arrow:not([aria-label])');
    arrows.forEach(function (b) { b.setAttribute('aria-label', 'Review carousel control'); });

    var imgs = root.querySelectorAll('.jdgm-cards-wrapper img:not([alt]), .jdgm-rev img:not([alt])');
    imgs.forEach(function (img) { img.setAttribute('alt', ''); img.setAttribute('role', 'presentation'); });
  }

  function run() {
    patch(document);

    var obs = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType === 1) patch(n);
        }
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  function deferred() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(run, { timeout: 2000 });
    } else {
      setTimeout(run, 300);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', deferred);
  } else {
    deferred();
  }
})();
